var _ellipse, _ellipse2, _path, _rect, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGolf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 24,
    rx: 15,
    ry: 6,
    fill: "#44C4A1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 22,
    rx: 2.5,
    ry: 1,
    fill: "#3F4347"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 6.5L10.25 12.1292L10.25 0.870834L23 6.5Z",
    fill: "#3A7EFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 1,
    height: 23,
    fill: "#ACACAC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 22,
    r: 2,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 23.9973C20.1046 23.9973 21 23.1019 21 21.9973C21 21.4813 20.8046 21.011 20.4838 20.6562C20.3578 21.2159 20.0207 21.9766 19.5 22.4973C18.8845 23.1129 17.9334 23.2745 17.3757 23.1645C17.7388 23.6689 18.3311 23.9973 19 23.9973Z",
    fill: "#E9EFF4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGolf);
export default __webpack_public_path__ + "static/media/IcGolf.8cedb709da46a98e9f8c3c0731b52c13.svg";
export { ForwardRef as ReactComponent };